export const getObjFromId = (id, arr) => {
  if (arr && (arr.length === 0 || typeof arr === "undefined")) return null;
  const item = arr.find((i) => i.id === id);
  return item ? item : null;
};
